/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { useContext } from 'react';
import {
    string,
    array,
    bool,
    arrayOf,
    shape,
} from 'prop-types';
import Loadable from 'react-loadable';
import { selectedSkuType } from '../common/types';
import DesktopMobile from '../../../../../helpers/DesktopMobile/DesktopMobile';
import { CrossMerch } from '../../../CrossMerchContainer/CrossMerchContainer';

const GraphqlFoodDetailsUIDesktop = Loadable({
    loader: () => import(/* webpackChunkName: "GraphqlFoodDetailsUIDesktopV1" */ './v1/GraphqlFoodDetailsUIDesktop'),
    loading: () => <div />,
});
const GraphqlFoodDetailsUIDesktopV2 = Loadable({
    loader: () => import(/* webpackChunkName: "GraphqlFoodDetailsUIDesktopV2" */ './v2/GraphqlFoodDetailsUIDesktop'),
    loading: () => <div />,
});

const GraphqlFoodDetailsUIMobile = Loadable({
    loader: () => import(/* webpackChunkName: "GraphqlFoodDetailsUIMobileV1" */ './v1/GraphqlFoodDetailsUIMobile'),
    loading: () => <div />,
});
const GraphqlFoodDetailsUIMobileV2 = Loadable({
    loader: () => import(/* webpackChunkName: "GraphqlFoodDetailsUIMobileV2" */ './v2/GraphqlFoodDetailsUIMobile'),
    loading: () => <div />,
});

const GraphqlFoodDetailsUI = ({
    shortDescription,
    productContents,
    longDescription,
    clubDescription,
    selectedSku,
    content,
    isPassportBundleProduct,
    productAttributes,
    isSinglePlaThree,
    renderDescriptionOnly,
    renderContentOnly,
    isPdpRedesignEnabled,
    productName,
    partNumber,
}) => {
    const { featureFlags = {} } = useContext(CrossMerch);
    const productContentsDescription = selectedSku?.longDescription || '';
    const additionalInformation = content?.entries?.[0]?.additional_information || [];
    return (
        <DesktopMobile
            desktop={() => (
                featureFlags['is-pdp-v-2-enabled'] ? (
                    <GraphqlFoodDetailsUIDesktopV2
                        productContentsDescription={productContentsDescription}
                        shortDescription={shortDescription}
                        productContents={productContents}
                        longDescription={longDescription}
                        content={content}
                        selectedSku={selectedSku}
                        additionalInformation={additionalInformation}
                        isPassportBundleProduct={isPassportBundleProduct || {}}
                        productAttributes={productAttributes}
                        isSinglePlaThree={isSinglePlaThree}
                        renderDescriptionOnly={renderDescriptionOnly}
                        renderContentOnly={renderContentOnly}
                        isPdpRedesignEnabled={isPdpRedesignEnabled}
                        productName={productName}
                        partNumber={partNumber}
                    />
                ) : (
                    <GraphqlFoodDetailsUIDesktop
                        productContentsDescription={productContentsDescription}
                        shortDescription={shortDescription}
                        productContents={productContents}
                        longDescription={longDescription}
                        content={content}
                        selectedSku={selectedSku}
                        additionalInformation={additionalInformation}
                        isPassportBundleProduct={isPassportBundleProduct || {}}
                    />
                )
            )}
            mobile={() => (
                featureFlags['is-pdp-v-2-enabled'] ? (
                    <GraphqlFoodDetailsUIMobileV2
                        productContentsDescription={productContentsDescription}
                        shortDescription={shortDescription}
                        productContents={productContents}
                        longDescription={longDescription}
                        clubDescription={clubDescription}
                        content={content}
                        selectedSku={selectedSku}
                        isPassportBundleProduct={isPassportBundleProduct || {}}
                        productAttributes={productAttributes}
                        isPdpRedesignEnabled={isPdpRedesignEnabled}
                        productName={productName}
                        partNumber={partNumber}
                    />
                ) : (
                    <GraphqlFoodDetailsUIMobile
                        productContentsDescription={productContentsDescription}
                        shortDescription={shortDescription}
                        productContents={productContents}
                        longDescription={longDescription}
                        clubDescription={clubDescription}
                        content={content}
                        selectedSku={selectedSku}
                        isPassportBundleProduct={isPassportBundleProduct || {}}
                        productAttributes={productAttributes}
                    />
                )
            )}
        />
    );
};

GraphqlFoodDetailsUI.defaultProps = {
    clubDescription: false,
    selectedSku: {},
    content: {},
    isPassportBundleProduct: {},
    productAttributes: [],
    isSinglePlaThree: false,
    renderDescriptionOnly: false,
    renderContentOnly: false,
    isPdpRedesignEnabled: false,
    productName: '',
    partNumber: '',
};

GraphqlFoodDetailsUI.propTypes = {
    content: shape({
        entries: arrayOf(shape({
            // Gets dynamic data from contentstack. Either image or copy or heading
            additional_information: array,
        })),
    }),
    clubDescription: bool,
    shortDescription: string.isRequired,
    productContents: array.isRequired,
    longDescription: string.isRequired,
    selectedSku: selectedSkuType,
    isPassportBundleProduct: shape({
        enable: bool,
    }),
    productAttributes: array,
    isSinglePlaThree: bool,
    renderDescriptionOnly: bool,
    renderContentOnly: bool,
    isPdpRedesignEnabled: bool,
    productName: string,
    partNumber: string,
};

export default GraphqlFoodDetailsUI;
